import { connect } from 'react-redux';
import { actions, selectors } from '../../../CollectionPanel/redux';
import { getIsDeviationInitialized, getUserCollectionsCount, getUserCollectionsHasMore } from '../../../CollectionPanel/redux/selectors';
import { removeQueues } from '../../../Notifications/redux/actionCreators';
const mapStateToProps = (state, { collectibleDeviation: { deviationId  }  })=>({
        isInitialized: getIsDeviationInitialized(state, deviationId),
        collectionsCount: getUserCollectionsCount(state, deviationId),
        hasMoreCollections: getUserCollectionsHasMore(state, deviationId),
        selectedFolderIds: selectors.getSelectedFolderIds(state, deviationId)
    });
const mapDispatchToProps = {
    initializeCollectionsForDeviation: actions.initializeDeviation,
    commitCollections: actions.commitCollectionsCustom,
    removeQueues
};
export default connect(mapStateToProps, mapDispatchToProps);
